export const classNameIconoBasura = "fa fas fa-trash download";
export const classNameIconoCruzCuadro= "fa fa-light fa-square-xmark";
export const classNameIconoFlechaRegresar= "fa fa-arrow-left";
export const classNameIconoMensaje = "fa-solid fa-message";
export const classNameIconoLupa = "fa fa-search";
export const classNameIconoMenos = "fa fa-solid fa-circle-minus";
export const classNameOjos = "fa fa-solid fa-eye";
export const classNameIconoAvionPapel = "fa fa-light fa-paper-plane";
export const classNameClock = "fa fa-solid fa-clock"
export const classNameDownloadPdf = "fa fa-regular fa-file-pdf";
export const classNameDownload = "fa-solid fa-file-arrow-down";
export const classNameIconoUpload = "fa fas fa-upload";
export const classNameIconoMessage = "fa fa-solid fa-message"
export const classNameCrossCircle = "fa fa-solid fa-circle-xmark"